import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import './styles.scss'
import { addConversation } from 'redux/actions/conversations/conversations'
import { setActiveUser } from 'redux/actions/tabs'
import composerActions from 'redux/actions/conversations/composerAct'
import { getParsedDate } from '../utils'
import { getStaticImage } from 'utils/statics'

const ChatMailBox = ({ id, type, channel, state, date, text, user }) => {
  const dispatch = useDispatch()
  const { push } = useHistory()
  const parsedDate = getParsedDate(date)

  const handleGoToMessage = () => {
    if (type === 'mail_subjects') {
      const userData = { _id: user._id, id: user.id, channels: [channel], state, isOnline: false }
      dispatch(addConversation(userData))
      dispatch(setActiveUser(userData.id))
      dispatch(composerActions.setCurrentSubject({ _id: id, name: text }))
    }
    push({
      pathname: '/dashboard/conversations/users',
      search: `?user_id=${user.id}`
    })
  }

  return (
    <div className='search-results-chatmail-box' onClick={handleGoToMessage}>
      <div className='search-results-chatmail-box__header'>
        <p
          className='search-results-chatmail-box__header-title text-ellipsis'
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <span className='search-results-chatmail-box__date'>{parsedDate.date}</span>
      </div>
      <div className='search-results-chatmail-box__footer'>
        <div className='search-results-chatmail-box__user'>
          <figure className='search-results-chatmail-box__user-avatar'>
            <img
              src={user?.picture || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
              alt={`avatar-${user?.name}`}
              onError={({ target }) => target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')}
            />
          </figure>
          <div className='search-results-chatmail-box__user-info'>
            <strong className='search-results-chatmail-box__user-name'>{user?.name}</strong>
            <span className='search-results-chatmail-box__time'>{parsedDate.time}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatMailBox
